import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "accordion";
var attributes = {
    PANEL_SELECTOR: 'panel-selector'
};
export var ACCORDION_CONSTANTS = {
    elementName: elementName,
    attributes: attributes
};
